module.exports = __webpack_public_path__ + "static/media/A8.1bab2c59.mp3";